import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  type SelectChangeEvent,
} from '@mui/material';
import type { ScreenRole } from './types';

const ROLES: { value: ScreenRole; label: string }[] = [
  { value: 'worklist', label: 'Worklist + Primary Viewer' },
  { value: 'primary-viewer', label: 'Primary Viewer Only' },
  { value: 'secondary-viewer', label: 'Secondary Viewer' },
  { value: 'prior-viewer', label: 'Prior / Comparison Viewer' },
  { value: 'unassigned', label: 'Unassigned' },
];

interface RoleSelectorProps {
  screenLabel: string;
  currentRole: ScreenRole;
  onChange: (screenLabel: string, role: ScreenRole) => void;
}

export function RoleSelector({ screenLabel, currentRole, onChange }: RoleSelectorProps) {
  const handleChange = (e: SelectChangeEvent) => {
    onChange(screenLabel, e.target.value as ScreenRole);
  };

  return (
    <FormControl size="small" fullWidth sx={{ mt: 1, maxWidth: 280 }}>
      <InputLabel id={`role-${screenLabel}`}>Role</InputLabel>
      <Select
        labelId={`role-${screenLabel}`}
        value={currentRole}
        label="Role"
        onChange={handleChange}
      >
        {ROLES.map(({ value, label }) => (
          <MenuItem key={value} value={value} dense>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
